module.exports = __webpack_public_path__ + "img/freehand-cn.dd32765.jpg";